
import React, { useState, useEffect, useRef, useMemo } from "react";
import DashboardPage from "../../layout/index";
import SalesmanList from "./Salesman-list";
import SalesmanOption from "./SalesmanOption";
import GoogleMap from "../../components/GoogleMapUpdated";
import getEmployeeList, {
  getEmployeeSchedule,
  getDdSchedule,
  getMarkerInfo,
  getStream,
  getLastLocation,
  getSnappedHistory,
  getDistanceTravelled,
  getDeviation,
  getIdleTime
} from "../../api/mapView";
import {
  formatCurrentStartDate,
  formatCurrentEndDate,
  getUserInfo,
} from "../../utility";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { getGlobalFilter } from "../../api/filters";
import { useLocation, useNavigate } from "react-router-dom";
import DropdownMulti from "../../components/DropdownMultiple";
import Dropdown from "../../components/Dropdown";
import Search from '../../assets/search-icon.svg';
import URL_MAPPING from "../../routes/constants";
import polyline from "@mapbox/polyline";
import { getMapViewPositions } from "../../utility/constant";
import {
  LmdDdScheduleEntry,
  normalizeDdScheduleResponse,
} from "./lmdDdSchedule";

interface Employee {
  emp_id: string;
  name: string;
  age: number;
  department: string;
}

export default function MapView() {
  const [selctedEmp, setSelectedEmp] = useState<any>("All employees");
  const [employeeData, setEmployeeData] = useState<Employee[]>([]);
  const [employeeSchedule, setEmployeeSchedule] = useState<any>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState<any | null>(null);
  const [startDate, setStartDate] = useState<any | null>();
  const [endDate, setEndDate] = useState<any | null>(null);
  const [selectedDate, setSelectedDate] = useState<any>();
  const [journeyPlanDate, setJourneyPlanDate] = useState<any>();
  const [loader, setLoader] = useState(false);
  const [locationData, setLocationData] = useState<any | null>([]);
  const [markarData, setMarkarData] = useState<any | null>(null);
  const [selectedEmpPopup, setSelectedEmpPopup] = useState<boolean>(false);
  const [selectedRoute, setSelectedRoute] = useState<string>("All employees");
  const [actualData, setActualdata] = useState<any>([]);
  const [lastLoader, setLastLoader] = useState<any>(false);
  const [empLoader, setEmpLoader] = useState<any>(false);
  const [actualDataLoader, setActualdataLoader] = useState<any>(false);
  const [routeForSelectedCustomer, setRouteForSelectedCustomer] =
    useState<any>("");
  const [vehicleLocation, setVehicleLoaction] = useState<any>();
  const [locationPoint, setLocationPoint] = useState<any>(false);
  const [startPoint, setStartPoint] = useState<any>([
    { lat: 24.774265, lng: 46.738586 },
  ]);
  const [snappedHistory, setSnappedHistory] = useState<any>();
  const [snappedHistoryFollowed, setSnappedHistoryFollowed] = useState<any>();
  const [vehicleAnimation, setMoveVehicleAnimation] = useState<any>(false);
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenPlan, setIsOpenPlan] = useState(true);
  const [minMax, setMinMax] = useState(true);
  const [reSize, setResize] = useState(true);
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [loadingFilter, setLoadingForFilter] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState<any>([]);
  const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>([]);
  const [selectedActiveStatus, setSelectedActiveStatus] = useState<any>("");
  const [selectedChannel, setSelectedChannel] = useState<any>([]);
  const [selectedFromReports, setSelectedFromReports] = useState(false);
  const [sortBy, setSortBy] = useState<string>("");
  const [idletime, setIdletime] = useState<any>(null);
  const [distanceTravelled, setDistance] = useState<any>(null);
  const [roadTrripId, setRoadTripId] = useState<any>(null);
  const [lmdDdSchedule, setLmdDdSchedule] = useState<LmdDdScheduleEntry[]>([]);
  const popupRef = useRef<HTMLDivElement>(null);
  const isSupervisor = useRef<Boolean>(false);
  const fromLMD = useRef<boolean>(false);
  const isLMDMapView =
    typeof window !== "undefined" &&
    localStorage.getItem("section") === "Delivery_My_Team";
  const shouldShowLmdDdSchedule =
    isLMDMapView && selectedSalesOffice.length > 0 && selectedRegion.length > 0;
  const visibleLmdPlannedRoutes = useMemo(() => {
    if (!shouldShowLmdDdSchedule || lmdDdSchedule.length === 0) return [];

    const employeeIds = new Set(
      employeeData.map((employee: any) => String(employee.emp_id))
    );

    let routes = lmdDdSchedule.filter((entry) =>
      employeeIds.has(String(entry.employee_details?.emp_id))
    );

    if (selctedEmp !== "All employees" && selctedEmp?.emp_id) {
      routes = routes.filter(
        (entry) =>
          String(entry.employee_details?.emp_id) === String(selctedEmp.emp_id)
      );
    }

    return routes;
  }, [
    shouldShowLmdDdSchedule,
    lmdDdSchedule,
    employeeData,
    selctedEmp,
  ]);
  const navigate = useNavigate();
  const location = useLocation();
  const toggleCollapsePlan = () => {
    setIsOpenPlan(!isOpenPlan);
  };

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const handleRouteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedRoute === e.target.value) {
      setSelectedRoute("All employees");
    } else {
      if (e.target.value === "actual") {
        setActualdata([]);
        setVehicleLoaction("");
        const { startTime, endTime } = getActiveDateRange();
        const data = {
          requested_emp_ids: (isSupervisor.current && roadTripRef.current) ? [selctedEmp.emp_id, roadTripRef.current] : [selctedEmp.emp_id],
          start_time: startTime,
          end_time: endTime,
        };
        setActualdataLoader(true);
        getStreamDataHistory(data, roadTripRef.current);
      } else if (e.target.value === 'compare') {
        getDataForCompare()
      }
      setSelectedRoute(e.target.value);
      setLocationPoint(true);
      setTimeout(() => {
        setLocationPoint(false);
      }, 5000);
    }
  };


  // actual route path api call
  const getActualPathCall = (person: any, res: any, startTime?: string, endTime?: string) => {
    const followedUser = res?.employee_details?.road_trip_emp_id
    setRoadTripId(followedUser)
    setActualdata([]);
    setVehicleLoaction("");
    setActualdataLoader(true);
    const fallbackRange = getActiveDateRange();
    const data = {
      requested_emp_ids: (isSupervisor.current && followedUser) ? [person.emp_id, followedUser] : [person.emp_id],
      start_time: startTime || fallbackRange.startTime,
      end_time: endTime || fallbackRange.endTime,
    };
    getStreamDataHistory(data, followedUser);

    setLocationPoint(true);
    setTimeout(() => {
      setLocationPoint(false);
    }, 5000);
  };

  const formatDate = (date: Date) => {
    return date.toISOString().split("T")[0];
  };

  function getActiveDateRange() {
    if (startDate && endDate) {
      return { startTime: startDate, endTime: endDate };
    }

    const activeDateString = selectedDateEmpRef.current || selectedDate;
    const baseDate = activeDateString ? new Date(activeDateString) : new Date();

    return {
      startTime: formatCurrentStartDate(baseDate),
      endTime: formatCurrentEndDate(baseDate),
    };
  }


  //  if user redirect from visit activty page it will render user info
  useEffect(() => {

    if (location.pathname === URL_MAPPING.SUPERVISORMAP) {
      isSupervisor.current = true
    } else {
      isSupervisor.current = false
    }
    
    // Check if we're in LMD mode based on user's section
    // LMD users have section "Delivery_My_Team" in localStorage
    const savedSection = localStorage.getItem("section");
    fromLMD.current = savedSection === "Delivery_My_Team";
    
    setSelectedEmp('All employees')
    const today = new Date();
    setDateRange(today);
    getEmployee();

  }, [location.pathname]);

  // this returen sterm id of an users present in the list 
  const getStreamData = async (emp_data: any[]) => {
    const empIds = emp_data?.map((emp: any) => emp.emp_id);
    const user_info = getUserInfo();
    const data = {
      emp_id: user_info.emp_id,
      requested_emp_ids: empIds,
    };
    await getStream(data)
      .then((res) => {
        getEventSource(res.data.stream_id);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let lastApiCallTime = 0;

  // with the time user location is upadated in every min api is called
  function handleUpdateLocation() {
    const currentTime = Date.now();
    const oneMinute = 10 * 1000;

    if (currentTime - lastApiCallTime >= oneMinute) {
      lastApiCallTime = currentTime;
      const data = {
        requested_emp_ids: (isSupervisor.current && roadTripRef.current) ? [selectedEmpRef.current.emp_id, roadTripRef.current] : [selectedEmpRef.current.emp_id],
        start_time: formatCurrentStartDate(
          new Date(selectedDateEmpRef.current)
        ),
        end_time: formatCurrentEndDate(new Date(selectedDateEmpRef.current)),
      };
      getStreamDataHistory(data, roadTripRef.current);
    } else {
      // const timeLeft = oneMinute - (currentTime - lastApiCallTime);
      // console.log(
      //   `Skipping API call. Please wait ${Math.ceil(timeLeft / 1000)} seconds.`
      // );
    }
  }

  const contineousCallFordata = () => {
    if (formatDate(new Date()) === selectedDateEmpRef.current) {
      handleUpdateLocation();
    }
  }

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (selectedEmpRef.current.emp_id) {
        contineousCallFordata();
      }
    }, 10000); // every 10 seconds

    return () => {
      // Cleanup on unmount
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const updateVehicleLastLocation = (data: any) => {
    if (formatDate(new Date()) === selectedDateEmpRef.current) {
      setVehicleLoaction({
        lat: Number(data.latitude),
        lng: Number(data.longitude),
      });
      contineousCallFordata()
    }
  };

  const selectedEmpRef = useRef(selctedEmp);
  const selectedDateEmpRef = useRef(selectedDate);
  const locationDataRef = useRef(locationData);
  const selectedRouteRef = useRef(selectedRoute);
  const roadTripRef = useRef(selectedRoute);

  useEffect(() => {
    selectedEmpRef.current = selctedEmp;
    selectedDateEmpRef.current = selectedDate;
    roadTripRef.current = roadTrripId;
    fetchIdleTime(selctedEmp, selectedDate)
  }, [selctedEmp, selectedDate, roadTrripId]);

  useEffect(() => {
    locationDataRef.current = locationData;
  }, [locationData]);

  useEffect(() => {
    selectedRouteRef.current = selectedRoute;
  }, [selectedRoute]);

  // formatting the strem response when the response get its update the response of last location api , thats show multiple users location on map
  const handleStreamResponse = (data: any) => {
    if (data?.init) {
      return;
    }
    const existingMarkerIndex = locationDataRef.current.findIndex(
      (marker: any) => marker.emp_id === data.emp_id
    );

    if (selectedEmpRef.current.emp_id === data.emp_id) {
      // check user is current and status is not idle
      if (selectedRouteRef.current === "actual") {
        return updateVehicleLastLocation(data);
      } else {
        return;
      }
    }
    if (selectedRoute === "All employees") {
      if (existingMarkerIndex !== -1) {
        // Update existing marker
        const updatedMarkers = [...locationDataRef.current];
        updatedMarkers[existingMarkerIndex] = {
          ...updatedMarkers[existingMarkerIndex],
          location: {
            lat: Number(data.latitude), // Update latitude
            lng: Number(data.longitude), // Update longitude
          },
          status:
            data.ischecked_in === "True"
              ? "at_location"
              : data.is_idle === "True"
                ? "idle"
                : "enroute",
        };
        setLocationData(updatedMarkers);
      } else {
        // Add new marker
        if (data.emp_id) {
          setLocationData([
            ...locationDataRef.current,
            {
              location: {
                lat: Number(data.latitude),
                lng: Number(data.longitude),
              },
              emp_id: data.emp_id,
              status:
                data.ischecked_in === "True"
                  ? "at_location"
                  : data.is_idle === "True"
                    ? "idle"
                    : "enroute",
            },
          ]);
        }
      }
    }
  };


  //  here event strem is called to show multiple user and there current location
  let eventSource: EventSource | null = null;

  const getEventSource = (streamId: number) => {
    const token = Cookies.get("token");

    const env = process.env.REACT_APP_ENV;
    let baseUrlGps = null;

    if (env === "development") {
      baseUrlGps = process.env.REACT_APP_DEV_GPS_API_URL;
    } else if (env === "staging") {
      baseUrlGps = process.env.REACT_APP_STAGING_GPS_API_URL;
    } else if (env === "production") {
      baseUrlGps = process.env.REACT_APP_PROD_GPS_API_URL;
    } else {
      console.error("No valid environment specified");
    }
    eventSource?.close();
    eventSource = new EventSource(
      `${baseUrlGps}/gps/stream/${streamId}?token=${token}`
    );
    eventSource.onmessage = (event: any) => {
      handleStreamResponse(JSON.parse(event.data));
    };

    eventSource.onerror = (err) => {
      console.error("EventSource error:", err);
      eventSource?.close();
    };
  };

  const stopEventSource = () => {
    if (eventSource) {
      eventSource.close();
      eventSource = null; // Reset the reference
    }
  };

  useEffect(() => {
    return () => {
      stopEventSource();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //  function for formatting the response
  const formatSnappedHistory = (data: any) => {
    const polyline = data?.polylines[selectedEmpRef.current.emp_id]?.features;
    setSnappedHistory(polyline);
    setVehicleLoaction(null);
  };

  const formatSnappedHistoryForSupervisor = (data: any, id: any) => {
    const polyline = data?.polylines[selectedEmpRef.current.emp_id]?.features;
    const polylineFollowed = data?.polylines[id]?.features;
    setSnappedHistory(polyline);
    setSnappedHistoryFollowed(polylineFollowed);
    setVehicleLoaction(null);
  };

  const getStreamDataHistory = async (data: any, followedUser: string) => {
    await getSnappedHistory(data)
      .then((res) => {
        isSupervisor.current ? formatSnappedHistoryForSupervisor(res.data, followedUser) : formatSnappedHistory(res.data);
        setMoveVehicleAnimation(true);
        setActualdataLoader(false);
        setTimeout(() => {
          setMoveVehicleAnimation(false);
        }, 3000);
      })
      .catch((error) => {
        setActualdataLoader(false);
        console.log(error);
      });
  };

  const fetchIdleTime = async (emp_id: any, data: any) => {
    try {
      const response = await getIdleTime(emp_id, data);
      setIdletime(response.data);
    } catch (error) {
      console.error("Error fetching idle time:", error);
    }
  };

  const fetchDistanceTravelled = async (emp_id: any, data: any) => {
    try {
      const response = await getDistanceTravelled(emp_id, data);
      setDistance(response.data);
    } catch (error) {
      console.error("Error fetching idle time:", error);
    }
  };

  const hanldeLocationData = (data: any) => {
    const convertedData = data.map((item: any) => ({
      ...item,
      location: {
        lat: parseFloat(item.location.lat),
        lng: parseFloat(item.location.lng),
      },
      status: "enroute",
    }));
    if (convertedData) {
      return convertedData;
    } else {
      return;
    }
  };

  const getLastLocationData = async (data: any) => {
    setLastLoader(true);
    const empIds = data.map((employee: any) => employee.emp_id);
    await getLastLocation(empIds)
      .then((res) => {
        setLocationData(hanldeLocationData(res?.data?.locations));
        setLastLoader(false);
      })
      .catch((error) => {
        setLastLoader(false);
        console.log(error);
        setLocationData([]);
      });
  };

  const setDateRange = (date: any) => {
    const formattedToday = formatDate(date);
    setSelectedDate(formattedToday);
    setJourneyPlanDate(formattedToday); // Initialize journey plan date
    selectedDateEmpRef.current = formattedToday;

    setStartDate(formatCurrentStartDate(date));
    setEndDate(formatCurrentEndDate(date));
  };

  // Date change handler for salesman list - refreshes employee list and calls subordinate API
  const handleSalesmanListDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = new Date(e.target.value);
    setRouteForSelectedCustomer("");
    if (!isNaN(selectedDate.getTime())) {
      setStartDate(formatCurrentStartDate(selectedDate));
      setEndDate(formatCurrentEndDate(selectedDate));

      const formattedToday = formatDate(selectedDate);
      setSelectedDate(formattedToday);
      
      // Sync journey plan date with salesman list date (one-way sync)
      setJourneyPlanDate(formattedToday);
      selectedDateEmpRef.current = formattedToday;

      // Refresh employee list with new date - pass the new date directly to avoid stale state
      getEmployee(formattedToday);

      // If an employee is selected, update their schedule
      if (selctedEmp !== "All employees" && selctedEmp.emp_id) {
        getEmpSchedule(selctedEmp, {
          start_date: formatCurrentStartDate(selectedDate),
          end_date: formatCurrentEndDate(selectedDate),
        });
        const idlparams = {
          date: formattedToday
        };
        const paramsD = {
          start_time: formatCurrentStartDate(new Date(selectedDate)),
          end_time: formatCurrentEndDate(new Date(selectedDate)),
        };
        fetchIdleTime(selctedEmp.emp_id, idlparams)
        fetchDistanceTravelled(selctedEmp.emp_id, paramsD)
      }
    }
  };

  // Date change handler for journey plan - only updates employee schedule, doesn't affect salesman list date
  const handleJourneyPlanDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = new Date(e.target.value);
    setRouteForSelectedCustomer("");
    if (!isNaN(selectedDate.getTime())) {
      // Update journey plan date state (separate from salesman list date)
      const formattedDate = formatDate(selectedDate);
      setJourneyPlanDate(formattedDate);
      selectedDateEmpRef.current = formattedDate;
      
      // Update start and end dates for the journey plan
      setStartDate(formatCurrentStartDate(selectedDate));
      setEndDate(formatCurrentEndDate(selectedDate));

      // Only update employee schedule if an employee is selected, don't refresh employee list
      // Don't update selectedDate state to avoid affecting salesman list date
      if (selctedEmp !== "All employees" && selctedEmp.emp_id) {
        getEmpSchedule(selctedEmp, {
          start_date: formatCurrentStartDate(selectedDate),
          end_date: formatCurrentEndDate(selectedDate),
        });
        const idlparams = {
          date: formattedDate
        };
        const paramsD = {
          start_time: formatCurrentStartDate(new Date(selectedDate)),
          end_time: formatCurrentEndDate(new Date(selectedDate)),
        };
        fetchIdleTime(selctedEmp.emp_id, idlparams)
        fetchDistanceTravelled(selctedEmp.emp_id, paramsD)
      }
    }
  };

  const covertLatLngTogeoLine = () => {
    const latLngs = snappedHistoryFollowed?.flatMap((feature: any) =>
      feature.geometry?.coordinates?.map(([lng, lat]: [number, number]) => ({ lat, lng }))
    );
    return polyline.encode(latLngs)
  }

  useEffect(() => {
    if (location.state) {
      const { id, selectDate } = location.state;
      setSelectedEmp({ emp_id: id });
      setSelectedDate(selectDate);
      setIsDropdownOpen(false);
      setLocationPoint(true);
      setVehicleLoaction(null);
      
      // LMD mode is determined by section, not navigation state
      // It's already set in the useEffect above based on localStorage section

      setTimeout(() => {
        setLocationPoint(false);
      }, 5000);

      const params = {
        start_date: formatCurrentStartDate(new Date(selectDate || new Date())),
        end_date: formatCurrentEndDate(new Date(selectDate || new Date())),
      };

      getEmpSchedule({ emp_id: id }, params);
      setStartDate(formatCurrentStartDate(new Date(selectDate)))
      setEndDate(formatCurrentEndDate(new Date(selectDate)))
      setSelectedFromReports(true);
      navigate(".", { replace: true });
    }
  }, [location.state, navigate])


  const handleEmpSected = (person: any, called: boolean) => {
    setRouteForSelectedCustomer("");
    if (selctedEmp.emp_id === person.emp_id && called) {
      setSelectedEmp("All employees");
      setIsDropdownOpen(false);
      return;
    } else {
      setSelectedEmp(person);
      setIsDropdownOpen(false);
      setLocationPoint(true);
      setVehicleLoaction(null);
      localStorage.removeItem("lastLatLngForActual");
      setTimeout(() => {
        setLocationPoint(false);
      }, 5000);
      
      // Sync journey plan date with selected date from left side and update API date params
      const dateToUse = selectedDate ? new Date(selectedDate) : new Date();
      const formattedDate = selectedDate || formatDate(new Date());
      
      setJourneyPlanDate(formattedDate);
      selectedDateEmpRef.current = formattedDate;
      // Update startDate and endDate so API calls use the synced date
      const startTime = formatCurrentStartDate(dateToUse);
      const endTime = formatCurrentEndDate(dateToUse);
      setStartDate(startTime);
      setEndDate(endTime);
      
      const params = {
        start_date: startTime,
        end_date: endTime,
      };

      getEmpSchedule(person, params);
      setSelectedFromReports(false);

    }
  };

  const getEmpSchedule = async (person: any, params: any) => {
    setLoader(true);
    setActualdataLoader(true);
    setSelectedRoute("actual");
    const sub_id = person.emp_id;
    await getEmployeeSchedule(sub_id, params)
      .then((res) => {
        setEmployeeSchedule(res.data);
        setStartPoint({
          lat: Number(res.data.planned_route_details.origin.lat),
          lng: Number(res.data.planned_route_details.origin.lng),
        });
        setLoader(false);
        getActualPathCall(person, res.data, params.start_date, params.end_date);

        fetchIdleTime(person.emp_id, {
          date: params.start_date
        });
        fetchDistanceTravelled(person.emp_id, { start_time: params.start_date, end_time: params.end_date })
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });

  };

  const getMarkerInfoData = async (emp_id: any) => {
    const params = {
      start_date: formatCurrentStartDate(new Date(selectedDate)),
      end_date: formatCurrentEndDate(new Date(selectedDate)),
    };
    const paramsD = {
      start_time: formatCurrentStartDate(new Date(selectedDate)),
      end_time: formatCurrentEndDate(new Date(selectedDate)),
    };
    Promise.all([
      getDistanceTravelled(emp_id, paramsD),
      getMarkerInfo(emp_id, params),
    ])
      .then(([
        distanceRes,
        markerRes]) => {
        setMarkarData({
          ...markerRes.data,
          distance: distanceRes.data || 0,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchLmdDdSchedule = async (dateOverride?: string) => {
    if (!isLMDMapView || selectedSalesOffice.length === 0 || selectedRegion.length === 0) {
      setLmdDdSchedule([]);
      return;
    }

    const userInfo = getUserInfo();
    const dateToUse = dateOverride
      ? new Date(dateOverride)
      : selectedDate
        ? new Date(selectedDate)
        : new Date();

    try {
      const salesOfficeIds = selectedSalesOffice.includes("all")
        ? (globalFilters?.sales_offices || []).map((office: any) => office.id)
        : selectedSalesOffice;

      const response = await getDdSchedule({
        supervisor_id: userInfo.emp_id,
        start_date: formatCurrentStartDate(dateToUse),
        end_date: formatCurrentEndDate(dateToUse),
        sales_office_ids: salesOfficeIds,
      });
      setLmdDdSchedule(normalizeDdScheduleResponse(response.data));
    } catch (error) {
      console.error("Failed to fetch LMD dd-schedule:", error);
      setLmdDdSchedule([]);
    }
  };

  const getEmployee = async (overrideDate?: string, overrideSortBy?: string) => {
    setSelectedEmp("All employees");
    setIsDropdownOpen(false);
    const data: any = {};
    
    // Use override date if provided, otherwise selected date or current date as start_date and end_date for API call
    const dateToUse = overrideDate ? new Date(overrideDate) : (selectedDate ? new Date(selectedDate) : new Date());
    data.start_date = formatCurrentStartDate(dateToUse);
    data.end_date = formatCurrentEndDate(dateToUse);
    
    const savedMode = localStorage.getItem("section");
    data.positions = getMapViewPositions(
      savedMode,
      !!isSupervisor.current,
      selectedChannel
    );

    if (selectedRegion.length > 0) {
      const regionsToAppend = selectedRegion.includes("all")
        ? globalFilters?.regions || []
        : selectedRegion;

      data.regions = regionsToAppend;
    }

    if (selectedSalesOffice.length > 0) {
      const salesOfficesToAppend = selectedSalesOffice.includes("all")
        ? (globalFilters?.sales_offices || []).map((s: any) => s.id)
        : selectedSalesOffice;

      data.sales_office_ids = salesOfficesToAppend;
    }

    if (selectedChannel.length > 0) {
      const channelsToAppend = selectedChannel.includes("all")
        ? (globalFilters?.channels || []).map((c: any) => c.id)
        : selectedChannel;

      data.channel_ids = channelsToAppend;
    }

    if (selectedActiveStatus !== "") {
      data.status = selectedActiveStatus;
    }

    setEmpLoader(true)

    const sortByToUse = overrideSortBy !== undefined ? overrideSortBy : sortBy;
    const queryParams = sortByToUse ? { sort_by: sortByToUse } : undefined;

    await getEmployeeList(data, queryParams)
      .then((res) => {

        if (location?.state) {
          setEmployeeData(res.data?.filter((emp: any) => emp.emp_id === location.state.id));
        } else {
          setEmployeeData(res.data);
        }
        setEmpLoader(false)
        if (selectedRegion.length > 0) {
          getLastLocationData(res.data);
          getStreamData(res.data);
        } else {
          setLocationData([]);
        }
        fetchLmdDdSchedule(overrideDate);

      })
      .catch((error) => {
        setEmpLoader(false)
        console.log(error);
      });
  };

  // Fetch employees without applying any region/sales office/channel/status filters
  const getEmployeeWithoutFilters = async (overrideSortBy?: string) => {
    setSelectedEmp("All employees");
    setIsDropdownOpen(false);
    const data: any = {};

    // Use selected date or current date as start_date and end_date for API call
    const dateToUse = selectedDate ? new Date(selectedDate) : new Date();
    data.start_date = formatCurrentStartDate(dateToUse);
    data.end_date = formatCurrentEndDate(dateToUse);

    const savedMode = localStorage.getItem("section");
    data.positions = getMapViewPositions(
      savedMode,
      !!isSupervisor.current,
      selectedChannel
    );

    setEmpLoader(true)

    const sortByToUse = overrideSortBy !== undefined ? overrideSortBy : sortBy;
    const queryParams = sortByToUse ? { sort_by: sortByToUse } : undefined;

    await getEmployeeList(data, queryParams)
      .then((res) => {
        if (location?.state) {
          setEmployeeData(res.data?.filter((emp: any) => emp.emp_id === location.state.id));
        } else {
          setEmployeeData(res.data);
        }
        setEmpLoader(false)
        // No region selected -> clear map markers/stream
        setLocationData([]);
        setLmdDdSchedule([]);
      })
      .catch((error) => {
        setEmpLoader(false)
        console.log(error);
      });
  };

  const getEmployeeWithStatus = async (statusValue: string, overrideSortBy?: string) => {
    setSelectedEmp("All employees");
    setIsDropdownOpen(false);
    const data: any = {};
    
    // Use selected date or current date as start_date and end_date for API call
    const dateToUse = selectedDate ? new Date(selectedDate) : new Date();
    data.start_date = formatCurrentStartDate(dateToUse);
    data.end_date = formatCurrentEndDate(dateToUse);
    
    const savedMode = localStorage.getItem("section");
    data.positions = getMapViewPositions(
      savedMode,
      !!isSupervisor.current,
      selectedChannel
    );

    if (selectedRegion.length > 0) {
      const regionsToAppend = selectedRegion.includes("all")
        ? globalFilters?.regions || []
        : selectedRegion;

      data.regions = regionsToAppend;
    }

    if (selectedSalesOffice.length > 0) {
      const salesOfficesToAppend = selectedSalesOffice.includes("all")
        ? (globalFilters?.sales_offices || []).map((s: any) => s.id)
        : selectedSalesOffice;

      data.sales_office_ids = salesOfficesToAppend;
    }

    if (selectedChannel.length > 0) {
      const channelsToAppend = selectedChannel.includes("all")
        ? (globalFilters?.channels || []).map((c: any) => c.id)
        : selectedChannel;

      data.channel_ids = channelsToAppend;
    }

    if (statusValue !== "") {
      data.status = statusValue;
    }

    setEmpLoader(true)

    const sortByToUse = overrideSortBy !== undefined ? overrideSortBy : sortBy;
    const queryParams = sortByToUse ? { sort_by: sortByToUse } : undefined;

    await getEmployeeList(data, queryParams)
      .then((res) => {

        if (location?.state) {
          setEmployeeData(res.data?.filter((emp: any) => emp.emp_id === location.state.id));
        } else {
          setEmployeeData(res.data);
        }
        setEmpLoader(false)
        if (selectedRegion.length > 0) {
          getLastLocationData(res.data);
          getStreamData(res.data);
        } else {
          setLocationData([]);
        }
        fetchLmdDdSchedule();

      })
      .catch((error) => {
        setEmpLoader(false)
        console.log(error);
      });
  };

  const [activePopupIndex, setActivePopupIndex] = useState<number | null>(null);

  const handleSelectedEmpIcon = () => {
    setSelectedEmpPopup(!selectedEmpPopup);
    if (!selectedEmpPopup) {
      getMarkerInfoData(selctedEmp.emp_id);
    }
  };

  const infoIconClick = (index: number, id: any) => {
    setActivePopupIndex(activePopupIndex === index ? null : index);
    if (activePopupIndex !== index) {
      getMarkerInfoData(id);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setActivePopupIndex(null);
      } else {
        setSelectedEmpPopup(false)
      }
    };

    if (activePopupIndex !== null || selectedEmpPopup === true) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activePopupIndex]);

  const handleMarkerClick = (marker: any) => {
    setMarkarData(null);
    // setSelectedMarker(marker);
    // getMarkerInfoData(marker?.emp_id);
    setSelectedEmp(marker);
    setIsDropdownOpen(false);
    setLocationPoint(true);
    setVehicleLoaction(null);
    setTimeout(() => {
      setLocationPoint(false);
    }, 5000);
    const { startTime, endTime } = getActiveDateRange();
    const params = {
      start_date: startTime,
      end_date: endTime,
    };
    setEmployeeData(
      employeeData?.sort((a, b) =>
        a.emp_id === marker.emp_id ? -1 : b.emp_id === marker.emp_id ? 1 : 0
      )
    );
    getEmpSchedule(marker, params);
  };

  const handleMinMax = (flag: any) => {
    setIsOpen(flag);
    setIsOpenPlan(flag);
    setMinMax(flag);
  };

  const handleMobileMap = () => {
    setResize(!reSize);
  };

  const getGlobalFilters = async (data: any) => {
    if (loadingFilter) {
      return
    }
    try {
      setLoadingForFilter(true);
      const response = await getGlobalFilter(data);
      setLoadingForFilter(false);
      setGlobalFilters(response);
    } catch (error) {
      console.error("Error fetching global filters:", error);
    }
  };

  const handleFiltersUpdate = () => {
    const data: any = {};
    let regionValues = selectedRegion.includes("all")
      ? globalFilters?.regions || []
      : selectedRegion;

    if (regionValues.length > 0) {
      data["regions"] = regionValues;
    }

    let salesOfficeValues = selectedSalesOffice.includes("all")
      ? (globalFilters?.sales_offices || []).map((s: any) => s.id)
      : selectedSalesOffice;

    if (salesOfficeValues.length > 0) {
      data["sales_office_ids"] = salesOfficeValues;
    }

    let channelValues = selectedChannel.includes("all")
      ? (globalFilters?.channels || []).map((c: any) => c.id)
      : selectedChannel;

    if (channelValues.length > 0) {
      data["channel_ids"] = channelValues;
    }

    if (selectedActiveStatus && selectedActiveStatus !== "") {
      data["active_status"] = selectedActiveStatus;
    }

    data["endpoint"] = "map-view";
    data["start_date"] = formatCurrentStartDate(new Date());
    data["end_date"] = formatCurrentEndDate(new Date());
    const savedMode = localStorage.getItem("section");
    data["positions"] = getMapViewPositions(
      savedMode,
      !!isSupervisor.current,
      selectedChannel
    );
    console.log(isSupervisor.current)
    getGlobalFilters(data);
    // getEmployee();
  };

  useEffect(() => {
    handleFiltersUpdate()
  }, [selectedSalesOffice, selectedRegion, selectedActiveStatus, selectedChannel])

  useEffect(() => {
    setSelectedSalesOffice([]);
    setSelectedChannel([]);
  }, [selectedRegion]);

  useEffect(() => {
    if (!isLMDMapView) return;

    if (selectedRegion.length > 1) {
      setSelectedRegion([selectedRegion[0]]);
    }
    if (selectedSalesOffice.length > 1) {
      setSelectedSalesOffice([selectedSalesOffice[0]]);
    }
  }, [isLMDMapView, selectedRegion, selectedSalesOffice]);

  const regionOptions = isLMDMapView
    ? (globalFilters?.regions || []).map((region: string) => ({
        value: region,
        label: region,
      }))
    : [
        { value: "all", label: "All Regions" },
        ...(globalFilters?.regions || []).map((region: string) => ({
          value: region,
          label: region,
        })),
      ];

  const salesOfficeOptions = isLMDMapView
    ? (globalFilters?.sales_offices || []).map((sales: any) => ({
        value: sales.id,
        label: sales.name,
      }))
    : [
        { value: "all", label: "All Sales Office" },
        ...(globalFilters?.sales_offices || []).map((sales: any) => ({
          value: sales.id,
          label: sales.name,
        })),
      ];

  const handleRegionChange = (values: (string | number)[]) => {
    if (isLMDMapView) {
      const nextValue = values.length ? [values[values.length - 1]] : [];
      setSelectedRegion(nextValue);
      return;
    }
    setSelectedRegion(values);
  };

  const handleSalesOfficeChange = (values: (string | number)[]) => {
    if (isLMDMapView) {
      const nextValue = values.length ? [values[values.length - 1]] : [];
      setSelectedSalesOffice(nextValue);
      return;
    }
    setSelectedSalesOffice(values);
  };


  const getDataForCompare = () => {
    if (!snappedHistory) {
      return
    }
    const data = isSupervisor.current ? {
      "actual_geojson": snappedHistory[0].geometry,
      "planned_polyline": covertLatLngTogeoLine()
    } : {
      "actual_geojson": snappedHistory[0].geometry,
      "planned_polyline": employeeSchedule?.planned_route_details?.directions?.routes[0]?.polyline?.encodedPolyline
    }

    getDeviationData(data)
  }

  const [deviationData, setDeviationData] = useState()

  const getDeviationData = async (data: any) => {

    await getDeviation(data).then((res) => {
      setDeviationData(res?.data?.features)
    }).catch((error) => {
      console.log(error)
    })
  }


  const handleRefresh = () => {
    handleEmpSected(selctedEmp, false)
  }

  const handleClearBoxFilters = () => {
    setSelectedRegion([])
    setSelectedSalesOffice([])
    setSelectedChannel([])
    setLmdDdSchedule([])
    getEmployeeWithoutFilters()
  }

  const handleSortByChange = (value: string) => {
    setSortBy(value);
    getEmployee(undefined, value);
  };

  useEffect(() => {
    if (routeForSelectedCustomer) {
      setLocationPoint(true)
      setTimeout(() => {
        setLocationPoint(false);
      }, 2000);
    }

  }, [routeForSelectedCustomer])

  return (
    <DashboardPage>
      <div className="relative h-[calc(100vh-54px)] flex-grow md:flex overflow-y-auto scrollbar scrollbar-thin">
        <div
          className={` overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? "w-full md:w-[25%]  md:h-full" : "w-0"
            }`}
        >
          <div className="sticky top-0 z-20 w-full px-4 py-2">
            <div className="relative w-full border border-gray-300 rounded bg-white p-3">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <DropdownMulti
                  options={regionOptions}
                  selectedValues={selectedRegion}
                  onChange={handleRegionChange}
                  placeholder={"Select Region"}
                  className="w-full"
                  isSingleSelect={isLMDMapView}
                />
                <DropdownMulti
                  options={salesOfficeOptions}
                  selectedValues={selectedSalesOffice}
                  onChange={handleSalesOfficeChange}
                  disabled={selectedRegion.length === 0}
                  placeholder={"Select Sales Office"}
                  className="w-full"
                  isSingleSelect={isLMDMapView}
                />
                </div>
              <div className="w-full">

                <DropdownMulti
                  className="w-full md:col-span-2"
                  options={[
                    { value: 'all', label: 'All Channels' },
                    ...(globalFilters?.channels || []).map((channel: any) => ({
                      value: channel.id,
                      label: channel.name + " (" + channel.id + ")",
                    })),
                  ]}
                  selectedValues={selectedChannel}
                  onChange={setSelectedChannel}
                  disabled={selectedRegion.length === 0}
                  placeholder={"Select Channel"}
                />
              </div>

              {/* Date Filter */}
              <div className="mt-3">
                <div className="flex flex-col">
                  <label className="text-grey text-12 font-medium mb-1">{t('visit.select_date')}</label>
                  <input
                    className="font-semibold text-13 p-2 border rounded"
                    type="date"
                    onChange={handleSalesmanListDateChange}
                    value={selectedDate}
                    max={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>

              <div className="mt-2 flex items-center justify-between">
                <button
                  onClick={handleClearBoxFilters}
                  className={`px-3 py-1 bg-gray-200 text-black rounded text-12 transition hover:bg-gray-300 ${selectedRegion.length===0 && selectedSalesOffice.length===0 && selectedChannel.length===0 ? 'opacity-60 cursor-not-allowed' : ''}`}
                  disabled={selectedRegion.length===0 && selectedSalesOffice.length===0 && selectedChannel.length===0}
                >
                  Clear
                </button>
                <button
                  onClick={() => {
                    getEmployee();
                  }}
                  className="px-3 py-1 bg-purple hover:bg-[#D099D4] text-white rounded text-12 transition"
                >
                  Apply
                </button>
              </div>
              <div className="text-orange text-14 px-1 pt-2">{t("visit.selectRegionOrSalesOffice")}</div>
            </div>
          </div>
            <div className="flex gap-2 sticky top-0 z-10 w-full px-4 y-2 md:flex-wrap xl:flex-nowrap">
            <Dropdown
            label=""
              options={[
                { value: '', label: 'All Status' },
                { value: 'A', label: 'Active' },
                { value: 'I', label: 'Inactive' },
              ]}
              selectedValue={selectedActiveStatus}
              onChange={(value) => {
                setSelectedActiveStatus(value);
                // Trigger employee list update immediately when active status changes
                getEmployeeWithStatus(String(value));
              }}
              placeholder={"Status"}
            />
          </div>
          <SalesmanList
            selctedEmp={selctedEmp}
            handleEmpSected={handleEmpSected}
            employeeData={employeeData}
            isDropdownOpen={isDropdownOpen}
            setIsDropdownOpen={setIsDropdownOpen}
            selectedEmpPopup={selectedEmpPopup}
            handleSelectedEmpIcon={handleSelectedEmpIcon}
            infoIconClick={infoIconClick}
            popupref={popupRef}
            activePopupIndex={activePopupIndex}
            markarData={markarData}
            employeeSchedule={employeeSchedule}
            selectedFromReports={selectedFromReports}
            empLoader={empLoader}
            selectedMarker={selectedMarker}
            sortBy={sortBy}
            onSortByChange={handleSortByChange}
            fromLMD={isLMDMapView}
          />
        </div>

        {selctedEmp !== "All employees" ? (
          <>
            <div
              className={`border-none md:border-solid  md:border-l-2 md:border-r-2 w-full  p-4 px-6 min-h-[400px] 
                ${isOpen
                  ? "md:w-[50%]"
                  : isOpenPlan
                    ? "md:w-[75%]"
                    : "md:w-full"
                } 
               ${isOpenPlan ? "md:w-[50%]" : isOpen ? "md:w-[75%]" : "md:w-full"
                }  
               ${reSize ? "h-[100%]" : "h-[400px]"}
              `}
            >
              <div className="hidden md:block">
                <button
                  onClick={toggleCollapse}
                  style={!isOpen ? { left: "1%" } : {}}
                  className={`absolute  ${i18n.dir() === "rtl" ? 'right-[23.8%]' : 'left-[23.8%]'}  top-[50%] z-20 px-2 py-6 bg-[#D099D4]  to-purple-500 text-white text-sm font-semibold  transform transition-all duration-300 ease-in-out hover:scale-105 focus:outline-none flex items-center space-x-2`}
                >
                  <span>{isOpen ? "<" : ">"}</span>
                </button>
              </div>
              <GoogleMap
                showDirections={true}
                plannedData={
                  employeeSchedule?.planned_route_details?.directions?.routes
                }
                actualData={actualData}
                snappedHistory={snappedHistory}
                snappedHistoryFollowed={snappedHistoryFollowed}
                vehicleAnimation={vehicleAnimation}
                actualDataLoader={actualDataLoader}
                lastLoader={lastLoader}
                startPoint={startPoint}
                selectedRoute={selectedRoute}
                handleRouteChange={handleRouteChange}
                markarData={markarData}
                employeeSchedule={employeeSchedule}
                routeForSelectedCustomer={routeForSelectedCustomer}
                vehicleLocation={vehicleLocation}
                locationPoint={locationPoint}
                selectedDate={selectedDate}
                handleMinMax={handleMinMax}
                minMax={minMax}
                deviationData={deviationData}
                isSupervisor={isSupervisor.current}
                fromLMD={fromLMD.current}
                lmdPlannedRoutes={visibleLmdPlannedRoutes}
              />
              <div className="block md:hidden">
                <button
                  onClick={handleMobileMap}
                  className="absolute rotate-90 right-[50%] z-20 px-2 py-6 bg-[#D099D4]  to-purple-500 text-white text-sm font-semibold  transform transition-all duration-300 ease-in-out hover:scale-105 focus:outline-none flex items-center space-x-2"
                >
                  <span>{!reSize ? ">" : "<"}</span>
                </button>
              </div>
            </div>
            <div
              className={` overflow-hidden transition-all duration-500 ease-in-out ${isOpenPlan ? "w-full md:w-[30%]  md:h-full" : "w-0"
                }`}
            >
              <div>
                <button
                  onClick={toggleCollapsePlan}
                  style={!isOpenPlan ? { right: "1%" } : {}}
                  className={`hidden md:block absolute  ${i18n.dir() === "rtl" ? 'left-[28.6%]' : 'right-[28.6%]'}  top-[50%] z-20 px-2 py-6 bg-[#D099D4]  to-purple-500 text-white text-sm font-semibold transform transition-all duration-300 ease-in-out hover:scale-105 focus:outline-none flex items-center space-x-2`}
                >
                  <span>{isOpenPlan ? ">" : "<"}</span>
                </button>
              </div>
              <div>
                <SalesmanOption
                  employeeSchedule={employeeSchedule}
                  handleDateChange={handleJourneyPlanDateChange}
                  selectedDate={journeyPlanDate || selectedDate}
                  loader={loader}
                  setRouteForSelectedCustomer={setRouteForSelectedCustomer}
                  routeForSelectedCustomer={routeForSelectedCustomer}
                  idleTime={idletime}
                  distanceTravelled={distanceTravelled}
                  handleRefresh={handleRefresh}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className={`border-l-2 min-h-[420px]   md:h-full p-4 px-6 h-[320px] ${isOpen ? "w-full md:w-[75%]" : "w-full md:w-full"
                }  ${reSize ? "h-[calc(100vh-270px)]" : "h-[420px]"}`}
            >
              <div className="hidden md:block">
                <button
                  onClick={toggleCollapse}
                  style={!isOpen ? (i18n.dir() === "rtl" ? { right: "1%" } : { left: "1%" }) : {}}
                  className={`absolute ${i18n.dir() === "rtl" ? "right-[25%]" : "left-[25%]"} top-[50%] z-20 px-2 py-6 
                  bg-[#D099D4] to-purple-500 text-white text-sm font-semibold 
                  transform transition-all duration-300 ease-in-out hover:scale-105 
                  focus:outline-none flex items-center space-x-2`}
                >
                  <span>{isOpen ? "<" : ">"}</span>
                </button>
              </div>
              <GoogleMap
                showMarkers={true}
                markersData={locationData}
                setSelectedMarker={setSelectedMarker}
                selectedMarker={selectedMarker}
                handleMarkerClick={handleMarkerClick}
                employeeSchedule={employeeSchedule}
                routeForSelectedCustomer={routeForSelectedCustomer}
                markarData={markarData}
                handleCloseInfoWindow={() => setSelectedMarker(null)}
                handleMinMax={handleMinMax}
                minMax={minMax}
                actualDataLoader={actualDataLoader}
                lastLoader={lastLoader}
                deviationData={deviationData}
                fromLMD={fromLMD.current}
                lmdPlannedRoutes={visibleLmdPlannedRoutes}
              />
              <div className="flex items-center justify-center md:hidden ">
                <button
                  onClick={handleMobileMap}
                  className={`"absolute rotate-90 right-[50%]  z-20 px-2 py-6 bg-purple  to-purple-500 text-white text-sm font-semibold  transform transition-all duration-300 ease-in-out hover:scale-105 focus:outline-none flex items-center space-x-2`}
                >
                  <span>{!reSize ? ">" : "<"}</span>
                </button>
              </div>
              {selectedMarker && (
                <div className="md:hidden w-full bg-culightgrey h-auto p-6 mt-4 border border-gray-500 rounded">
                  <div className="text-16 font-bold">
                    {selectedMarker?.label}
                  </div>
                  <div className="pt-2">
                    {isLMDMapView ? (
                      <>
                        <p>
                          {t("visit.total_visit")} : {markarData?.total_visits}
                        </p>
                        <p>
                          {t("visit.total_delivered_visits")} :{" "}
                          {markarData?.total_delivered_visits ??
                            markarData?.successful_visits}
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          {t("visit.total_travel")} :
                          {markarData?.distance.distance_metres}{" "}
                          {t("visit.km")}
                        </p>
                        <p>
                          {t("visit.total_visit")} : {markarData?.total_visits}
                        </p>
                        <p>
                          {t("visit.successful_visit")} :{" "}
                          {markarData?.successful_visits}
                        </p>
                        <p>
                          {t("visit.failed_visit")}: {markarData?.failed_visits}{" "}
                        </p>
                        <p>
                          {t("visit.collection_visit")}:{" "}
                          {markarData?.productive_visits}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </DashboardPage>
  );
}
